/**
 * Small Header Gallery — "View All Photos" modal trigger
 *
 * Injects a "View All Photos" button below each .is-style-small-header-gallery
 * and opens a Swiper dialog showing all images (including the CSS-hidden ones
 * past the 6th) when the button or any individual image is clicked.
 *
 * @version 2026.06.03
 */

document.addEventListener('DOMContentLoaded', () => {
	const settings = {
		class: 'small-header-gallery__view-all',
		text: 'View All Photos',
	};

	const galleries = document.querySelectorAll('.wp-block-gallery.is-style-small-header-gallery');
	if (!galleries.length) return;

	galleries.forEach((gallery) => {
		const fullCount = gallery.querySelectorAll('figure.wp-block-image').length;
		const count = Math.min(fullCount, 6);
		gallery.classList.add(`has-${count}-images`);

		if (fullCount > 6) {
			const firstImageLink = gallery.querySelector('figure.wp-block-image button');
			const viewAll = document.createElement('button');
			viewAll.className = settings.class;
			viewAll.type = 'button';
			viewAll.textContent = settings.text;
			viewAll.addEventListener('click', function (event) {
				// Stop page from jumping to top
				event.preventDefault();

				// Target the very first image link inside your gallery
				if (firstImageLink) {
					firstImageLink.click();
				}
			});
			gallery.after(viewAll);
		}
	});
});
